import { API_AUTH } from "./common";

const QuanLyCongViecApi = {
  list: ({
    tenKH,
    loaiKH,
    tinhtrangKH,
    trangthaiKH,
    nguonKH,
    pageIndex,
    pageSize,
  }) =>
    API_AUTH.get(
      `quanlynhanvien/quan-ly-cong-viec?tenKH=${tenKH}&loaiKH=${loaiKH}&tinhtrangKH=${tinhtrangKH}&trangthaiKH=${trangthaiKH}&nguonKH=${nguonKH}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
      {}
    ),
};

export default QuanLyCongViecApi;
